import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { MyHttpClient } from '../../app/http-client.service';
import { throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class HostAdjustmentService {
  server = environment.server;
  orderBaseUrl = `${this.server}/api/orders`;

  constructor(private http: MyHttpClient) {}

  hostRefundDetails(orderId: string, adjustmentObj: object, role: string) {
    const requestBody = { adjustmentObj, role };
    return this.http.post(`${this.orderBaseUrl}/${orderId}/refund`, requestBody).pipe(catchError(this.handleError));
  }

  hostDebitDetails(orderId: string, adjustmentObj: object) {
    const requestBody = { adjustmentObj };
    return this.http.post(`${this.orderBaseUrl}/${orderId}/captainRemarks`, requestBody).pipe(catchError(this.handleError));
  }

  private handleError(error: HttpErrorResponse) {
    if (error.error instanceof ErrorEvent) {
      console.error('An error occurred:', error.error.message);
    } else {
      console.error(`Backend returned code ${error.status}, body was: ${error.error}`);
    }
    return throwError(error);
  }
}
